module.exports = __webpack_public_path__ + "static/img/yeswecan0024.c2519a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0024.png
// module id = 590
// module chunks = 1